module.exports = __webpack_public_path__ + "static/img/about-title.3f69dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/about-title.png
// module id = VF2L
// module chunks = 0